import { useEffect, useState } from 'react';
import Button from '../../../components/button';
import { apiReadVideoAction } from '@/api';
import { showToast } from '@/utils/utils';
import RadioBox from '@/components/radioBox';
interface Props {
  onCancel?: (e: any) => void;
}
// const options = [
//   {
//     label: '眨眼',
//     value: '1',
//   },
//   {
//     label: '张口',
//     value: '2',
//   },
//   {
//     label: '摇头',
//     value: '3',
//   },
//   {
//     label: '点头',
//     value: '4',
//   },
// ];

export default function VideoLoading({ onCancel }: Props) {
  const urlParams = new URLSearchParams(window.location.search);
  const iccid = urlParams.get('iccid') || '';
  //   const [faceType, setfaceType] = useState<string>('');
  const [checkProtocol, setCheckProtocol] = useState<boolean>(true);

  useEffect(() => {
    getCameraPermission();
  }, []); // eslint-disable-line
  // 取url中iccid的参数
  async function getCameraPermission() {
    const res = await apiReadVideoAction({ iccid });
    if (res.data?.data?.code === 0) {
      //   setfaceType(res.data?.data?.data);
    } else if (res.data?.data?.code === 60002) {
      showToast(res.data?.data?.msg);
      onCancel && onCancel(false);
    } else {
      onCancel && onCancel(false);
      showToast(res.data?.data?.msg);
    }
  }
  async function onOk() {
    onCancel && onCancel(true);
  }

  return (
    <div className="pt-0 pb-20 pl-20 pr-20">
      <div className="text-center mt-20">
        <div className="font-size-18 mb-5">为保障账户安全</div>
        <div className="font-size-14" style={{ color: '#9E9E9E' }}>
          需采集您的人脸信息以核实身份
        </div>
      </div>

      <div className="pos-r h-180 mt-30 mb-30">
        <img className="pos-a bh-100 reverseside-img" src="/pic/certification/reverseside1.png" alt="" />
      </div>
      <div className="d-flex-r align-center pl-20">
        <img style={{ width: 18 }} className="mr-5" src="/pic/certification/reverseside2.png" alt="" />
        请正对屏幕使面部位于取经框中
      </div>
      <div className="d-flex-r align-center mt-10 pl-20">
        <img style={{ width: 18 }} className="mr-5" src="/pic/certification/reverseside3.png" alt="" />
        请保持光线充足，避免光照过强或过弱
      </div>
      <div className="d-flex-r align-center mt-10 pl-20 mb-20">
        <img style={{ width: 18 }} className="mr-5" src="/pic/certification/reverseside4.png" alt="" />
        根据画面提升完成单个或多个动作检测
      </div>
      <div className="d-flex-r align-center mt-10  mb-20">
        <RadioBox
          className="mr-5"
          checkedImg={'active'}
          value={checkProtocol}
          onChange={() => setCheckProtocol(!checkProtocol)}
        />
        <div className="font-size-12" style={{ color: '#9E9E9E' }}>
          {' '}
          同意采集并使用人脸信息用于核实身份
        </div>
      </div>

      <Button
        type="primary"
        disabled={!checkProtocol}
        className="mt-10 ml-20 mr-20 button-primary"
        size="lg"
        shape="circle"
        long
        onClick={() => onOk()}
      >
        开始人脸识别
      </Button>
    </div>
  );
}
